import { useState, useEffect } from "react";
import { API, useAuth } from "@/App";
import axios from "axios";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { Save } from "lucide-react";
import { useContent } from "@/lib/content";
import { VITALS } from "@/pages/About";

export const VitalsEditor = () => {
  const { token } = useAuth();
  const { content, refresh } = useContent();
  const [vitals, setVitals] = useState({});
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    setVitals(Object.fromEntries(VITALS.map((v) => [v.key, content[`about.vital.${v.key}`]?.content || v.value])));
  }, [content]);

  const saveVitals = async () => {
    setSaving(true);
    try {
      const sections = Object.fromEntries(VITALS.map((v) => [`about.vital.${v.key}`, { content: vitals[v.key] || "" }]));
      await axios.put(`${API}/admin/content`, { sections }, { headers: { Authorization: `Bearer ${token}` } });
      await refresh();
      toast.success("Vitals saved!");
    } catch (error) {
      toast.error("Failed to save");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div data-testid="admin-vitals-editor">
      <h1 className="font-heading text-3xl text-charcoal mb-2">About Me / Vitals</h1>
      <p className="font-body text-stone-grey mb-8">Edit your personal stats displayed on the About page</p>

      <div className="glass rounded-xl p-6">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {VITALS.map((v) => (
            <div key={v.key}>
              <Label className="font-body text-sm text-stone-grey mb-2 block">{v.label}</Label>
              <Input data-testid={`vital-input-${v.key}`} value={vitals[v.key] || ""} onChange={(e) => setVitals({ ...vitals, [v.key]: e.target.value })} className="form-input" />
            </div>
          ))}
        </div>
        <Button onClick={saveVitals} disabled={saving} className="btn-primary mt-6" data-testid="vitals-save-btn">
          {saving ? "Saving..." : <><Save className="w-4 h-4 mr-2" /> Save Vitals</>}
        </Button>
      </div>
    </div>
  );
};
